// eslint-disable-next-line no-unused-vars
import React, {useState, useRef} from 'react';
import styled from 'styled-components';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import wikiData from '../utils/wikiData';
import ReactMarkdown from 'react-markdown';

const WikiContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 900px;
  margin: auto;
  padding: 20px;
  color: #fff;
`;

const Sidebar = styled.div`
  position: sticky;
  top: 20px;
  padding: 15px;
  border-radius: 8px;
  width: 250px;
  height: fit-content;

  @media (max-width: 768px) {
    display: none;
  }
`;

const SidebarButton = styled.button`
  padding: 10px;
  width: 150px;
  margin-bottom: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  color: white;
  border: none;

  &:hover {
    color: #000;
  }
`;

const SubCategoryList = styled.ul`
  list-style: none;
  padding: 0;
  margin-left: 15px;

  li {
    cursor: pointer;
    padding: 5px 0;
    transition: color 0.3s;
    font-size: 14px;

    &:hover {
      color: #ffcc00;
    }
  }
`;

const Content = styled.div`
  flex-grow: 1;
  padding: 20px;
  border-radius: 8px;

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 10px auto;
  }
`;

const MobileDropdown = styled.select`
  display: none;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    display: block;
  }
`;

const WikiPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const contentRef = useRef(null);

  const handleCategoryClick = category => {
    setSelectedCategory(prev => (prev === category ? null : category));
    setSelectedSubCategory(null);
  };

  const handleSubCategoryClick = subCategory => {
    setSelectedSubCategory(subCategory);
    if (contentRef.current) {
      contentRef.current.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  };

  return (
    <PageContentComponent>
      <div ref={contentRef}>
        <PageContainerTitleComponent title="Wiki • Guide" />
      </div>
      <WikiContainer>
        <MobileDropdown
          onChange={e => {
            const [category, subCategory] = e.target.value.split('|');
            setSelectedCategory(category);
            setSelectedSubCategory(subCategory || null);
          }}
        >
          <option value="">Select a topic</option>
          {Object.keys(wikiData).map(category =>
            Object.keys(wikiData[category]).map(subCategory => (
              <option key={`${category}|${subCategory}`} value={`${category}|${subCategory}`}>
                {category} - {subCategory}
              </option>
            ))
          )}
        </MobileDropdown>

        <div style={{display: 'flex', gap: '20px'}}>
          <Sidebar>
            {Object.keys(wikiData).map(category => (
              <div key={category}>
                <SidebarButton onClick={() => handleCategoryClick(category)}>{category}</SidebarButton>
                {selectedCategory === category && (
                  <SubCategoryList>
                    {Object.keys(wikiData[category]).map(subCategory => (
                      <li key={subCategory} onClick={() => handleSubCategoryClick(subCategory)}>
                        {subCategory}
                      </li>
                    ))}
                  </SubCategoryList>
                )}
              </div>
            ))}
          </Sidebar>
          <Content>
            {selectedCategory && <h2>{selectedCategory}</h2>}
            {selectedSubCategory ? (
              <>
                <h3>{selectedSubCategory}</h3>
                <ReactMarkdown>{wikiData[selectedCategory][selectedSubCategory]}</ReactMarkdown>
              </>
            ) : (
              <p>Select a topic to view details.</p>
            )}
          </Content>
        </div>
      </WikiContainer>
    </PageContentComponent>
  );
};

export default WikiPage;
